import { Injectable } from '@angular/core';
import { NotepadType, PortalSearchParametersSuper } from 'ep-bt-field-agent-proxy';
import { CustomerProductPurchaseSearchDateRange, DefaultDocFilterType, SearchPageNames, NotepadTypeNames } from 'ep-bt-controls';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaFilterService {

  pageName: string;
  filterFlag = false;
  defaultNotepadDateOption: any = {
    name: '(All dates)',
    dateId: 'AllDates'
  };

  defaultProductsPurchasedDateOption: any = {
    name: 'Last 30 days',
    dateId: CustomerProductPurchaseSearchDateRange.Last30Days
  };

  // for customer opportunity
  // isOpportunityFilter: boolean = false;
  selectedOpportunityStatusId = -2;
  selectedOpportunityBranchId = -1;
  opportunitySearchValue: string = null;

  // for dashboard opportunity
  selectedDashboardOpportunityStatusId = -2;
  selectedDashboardOpportunityBranchId = -1;
  dashboardOpportunitySearchValue: string = null;

  // for customer notepads
  // isNotepadFilter: boolean = false;
  notepadSubject: string = null;
  notepadCustomer: string;
  selectedNotepadTypeId: number;
  selectedDateOptionId: string = this.defaultNotepadDateOption.dateId;
  selectedNotepadType: NotepadType;

  // for dashboard notepads
  notepadDashboardSubject: string = null;
  notepadDashboardCustomer = '';
  selectedDashboardNotepadTypeId: number;
  selectedDashboardDateOptionId: string = this.defaultNotepadDateOption.dateId;
  selectedDashboardNotepadType: NotepadType;

  // for product purchased
  purchasedProductSearch: string = null;
  purchasedJobrefSearch = '';
  selectedPurchasedBranchId = -1;
  selectedPurchasedDateOptionId: string = CustomerProductPurchaseSearchDateRange.Last30Days;
  purchasedProductStartDate: Date;
  purchasedProductEndDate: Date;

  // for customer Documents

  selectedQuotesSearchType: string = DefaultDocFilterType.QuoteNumber;
  selectedOrdersSearchType: string = DefaultDocFilterType.OrderNumber;
  selectedTempOrdersSearchType: string = DefaultDocFilterType.OrderNumber;
  selectedInvoicesSearchType: string = DefaultDocFilterType.InvoiceNumber;
  selectedCreditSearchType: string = DefaultDocFilterType.CreditNoteNumber;

  quotesFilter: PortalSearchParametersSuper[] = [];
  ordersFilter: PortalSearchParametersSuper[] = [];
  tempOrdersFilter: PortalSearchParametersSuper[] = [];
  invoicesFilter: PortalSearchParametersSuper[] = [];
  creditFilter: PortalSearchParametersSuper[] = [];

  // for dashboard Documents

  selectedDashboardQuotesSearchType: string = DefaultDocFilterType.QuoteNumber;
  selectedDashboardOrdersSearchType: string = DefaultDocFilterType.OrderNumber;
  selectedDashboardTempOrdersSearchType: string = DefaultDocFilterType.OrderNumber;
  selectedDashboardInvoicesSearchType: string = DefaultDocFilterType.InvoiceNumber;
  selectedDashboardCreditSearchType: string = DefaultDocFilterType.CreditNoteNumber;

  quotesDashboardFilter: PortalSearchParametersSuper[] = [];
  ordersDashboardFilter: PortalSearchParametersSuper[] = [];
  tempOrdersDashboardFilter: PortalSearchParametersSuper[] = [];
  invoicesDashboardFilter: PortalSearchParametersSuper[] = [];
  creditDashboardFilter: PortalSearchParametersSuper[] = [];

  // for dashboard calloff orders
  selectedDashboardCalloffCustomer: string = null;

  // for dashboard Statements
  selectedDashboardStatementsCustomer: string = null;

  // for dashboard stockstansfers
  selectedDashboardstockTransfersSearchType: string = DefaultDocFilterType.OrderNumber;
  stockTransfersDashboardFilter: PortalSearchParametersSuper[] = [];

  // for dashboard purchase orders
  selectedDashboardPurchaseOrderSearchType: string = DefaultDocFilterType.PurchaseOrderNumber;
  purchaseOrderDashboardFilter: PortalSearchParametersSuper[] = [];

  // for dashboard work order
  selectedDashboardWorkOrderSearchType: string = DefaultDocFilterType.WorksOrderNumber;
  workOrderDashboardFilter: PortalSearchParametersSuper[] = [];

  constructor() { }

  isFilterApplied(pageName, fromDashbard, isGridLoad: boolean = false): boolean {
    let flag = false;
    switch (pageName) {
      case SearchPageNames.DashboardOpportunitySearch:
          flag = this.selectedDashboardOpportunityStatusId != -2 || this.selectedDashboardOpportunityBranchId != -1 ? true : false;
          break;
      case SearchPageNames.CustomerOpportunity:
          flag = this.selectedOpportunityStatusId != -2 || this.selectedOpportunityBranchId != -1 ? true : false;
          if (isGridLoad && !flag) {
            flag = this.opportunitySearchValue != null ? true : false;
          }
          break;
      case SearchPageNames.CustomerNotepad:
          flag = (this.selectedNotepadType && this.selectedNotepadType.name != NotepadTypeNames.All) || this.selectedDateOptionId != this.defaultNotepadDateOption.dateId ? true : false;
          break;
      case SearchPageNames.DashboardNotepadSearch:
          flag = this.notepadDashboardCustomer != '' ||
          (this.selectedDashboardNotepadType && this.selectedDashboardNotepadType.name != NotepadTypeNames.All) ||
          this.selectedDashboardDateOptionId != this.defaultNotepadDateOption.dateId ? true : false;
          break;
      case SearchPageNames.CustomerProductsPurchased:
          flag = this.purchasedJobrefSearch != '' || this.selectedPurchasedBranchId != -1 || this.selectedPurchasedDateOptionId != CustomerProductPurchaseSearchDateRange.Last30Days ? true : false;
          break;
      case SearchPageNames.CustomerOrders:
          if (fromDashbard) {
            flag = this.checkDocFilter(this.ordersDashboardFilter, this.selectedDashboardOrdersSearchType, DefaultDocFilterType.OrderNumber, isGridLoad, fromDashbard);
          } else {
            flag = this.checkDocFilter(this.ordersFilter, this.selectedOrdersSearchType, DefaultDocFilterType.OrderNumber, isGridLoad, fromDashbard);
          }
          break;
      case SearchPageNames.CustomerQuotes:
          if (fromDashbard) {
            flag = this.checkDocFilter(this.quotesDashboardFilter, this.selectedDashboardQuotesSearchType, DefaultDocFilterType.QuoteNumber, isGridLoad, fromDashbard);
          } else {
            flag = this.checkDocFilter(this.quotesFilter, this.selectedQuotesSearchType, DefaultDocFilterType.QuoteNumber, isGridLoad, fromDashbard);
          }
          break;
      case SearchPageNames.CustomerTempOrders:
          if (fromDashbard) {
            flag = this.checkDocFilter(this.tempOrdersDashboardFilter, this.selectedDashboardTempOrdersSearchType, DefaultDocFilterType.OrderNumber, isGridLoad, fromDashbard);
          } else {
            flag = this.checkDocFilter(this.tempOrdersFilter, this.selectedTempOrdersSearchType, DefaultDocFilterType.OrderNumber, isGridLoad, fromDashbard);
          }
          break;
      case SearchPageNames.CustomerCredit:
          if (fromDashbard) {
            flag = this.checkDocFilter(this.creditDashboardFilter, this.selectedDashboardCreditSearchType, DefaultDocFilterType.CreditNoteNumber, isGridLoad, fromDashbard);
          } else {
            flag = this.checkDocFilter(this.creditFilter, this.selectedCreditSearchType, DefaultDocFilterType.CreditNoteNumber, isGridLoad, fromDashbard);
          }
          break;
      case SearchPageNames.CustomerInvoices:
          if (fromDashbard) {
            flag = this.checkDocFilter(this.invoicesDashboardFilter, this.selectedDashboardInvoicesSearchType, DefaultDocFilterType.InvoiceNumber, isGridLoad, fromDashbard);
          } else {
            flag = this.checkDocFilter(this.invoicesFilter, this.selectedInvoicesSearchType, DefaultDocFilterType.InvoiceNumber, isGridLoad, fromDashbard);
          }
          break;
      case SearchPageNames.DashboardStockTranferSearch:
          flag = this.checkDocFilter(this.stockTransfersDashboardFilter, this.selectedDashboardstockTransfersSearchType, DefaultDocFilterType.OrderNumber, isGridLoad, fromDashbard);
          break;
      case SearchPageNames.DashboardPurchaseOrderSearch:
          flag = this.checkDocFilter(this.purchaseOrderDashboardFilter, this.selectedDashboardPurchaseOrderSearchType, DefaultDocFilterType.PurchaseOrderNumber, isGridLoad, fromDashbard);
          break;
      case SearchPageNames.DashboardWorkOrderSearch:
          flag = this.checkDocFilter(this.workOrderDashboardFilter, this.selectedDashboardWorkOrderSearchType, DefaultDocFilterType.WorksOrderNumber, isGridLoad, fromDashbard);
          break;
      case SearchPageNames.CustomerCallOffOrders:
          if (isGridLoad) {
            flag = this.selectedDashboardCalloffCustomer != null ? true : false;
          }
          break;
      case SearchPageNames.CustomerStatements:
          if (isGridLoad) {
            flag = this.selectedDashboardStatementsCustomer != null ? true : false;
          }
          break;
      default:
          break;
    }
    return flag;
  }

  checkDocFilter(filters, filterType, defaultFilterType, isLoadGrid, fromDashbard): boolean {
    let flag = false;
    if (filterType != defaultFilterType) {
      flag = filters.length != 0 && filters.find(item => item.propertyName == filterType) ? true : false;
    }
    if (fromDashbard && isLoadGrid && !flag && filters.length != 0) {
      const item = filters.find(i => i.propertyName == filterType);
      if (item) {
        flag = item.searchValue != null && item.searchValue != undefined ? true : false;
      }
    }
    return flag;
  }

  setDefaultFilterValues(pageName, isSelected: boolean = false) {
    switch (pageName) {
      case SearchPageNames.DashboardOpportunitySearch:
          this.selectedDashboardOpportunityStatusId = -2;
          this.selectedDashboardOpportunityBranchId = -1;
          this.dashboardOpportunitySearchValue = null;
          break;
      case SearchPageNames.DashboardNotepadSearch:
          this.notepadDashboardSubject = null;
          this.notepadDashboardCustomer = '';
          this.selectedDashboardNotepadTypeId = 0;
          this.selectedDashboardDateOptionId = this.defaultNotepadDateOption.dateId;
          this.selectedDashboardNotepadType = null;
          break;
      case SearchPageNames.DashboardDocumentsSearch:
          this.selectedDashboardQuotesSearchType = DefaultDocFilterType.QuoteNumber;
          this.selectedDashboardOrdersSearchType = DefaultDocFilterType.OrderNumber;
          this.selectedDashboardTempOrdersSearchType = DefaultDocFilterType.OrderNumber;
          this.selectedDashboardInvoicesSearchType = DefaultDocFilterType.InvoiceNumber;
          this.selectedDashboardCreditSearchType = DefaultDocFilterType.CreditNoteNumber;

          this.quotesDashboardFilter = [];
          this.ordersDashboardFilter = [];
          this.tempOrdersDashboardFilter = [];
          this.invoicesDashboardFilter = [];
          this.creditDashboardFilter = [];

          // for dashboard calloff orders
          this.selectedDashboardCalloffCustomer = null;

          // for dashboard Statements
          this.selectedDashboardStatementsCustomer = null;

          // for dashboard stockstansfers
          this.selectedDashboardstockTransfersSearchType = DefaultDocFilterType.OrderNumber;
          this.stockTransfersDashboardFilter = [];

          // for dashboard purchase orders
          this.selectedDashboardPurchaseOrderSearchType = DefaultDocFilterType.PurchaseOrderNumber;
          this.purchaseOrderDashboardFilter = [];

          // for dashboard work order
          this.selectedDashboardWorkOrderSearchType = DefaultDocFilterType.WorksOrderNumber;
          this.workOrderDashboardFilter = [];
          break;
      case SearchPageNames.CustomerDetailsSearch:
          this.selectedOpportunityStatusId = -2;
          this.selectedOpportunityBranchId = -1;
          this.opportunitySearchValue = null;

          this.notepadSubject = null;
          this.selectedNotepadTypeId = 0;
          this.selectedDateOptionId = this.defaultNotepadDateOption.dateId;
          this.selectedNotepadType = null;

          this.purchasedProductSearch = null;
          this.purchasedJobrefSearch = '';
          this.selectedPurchasedBranchId = -1;
          this.selectedPurchasedDateOptionId = CustomerProductPurchaseSearchDateRange.Last30Days;
          this.purchasedProductStartDate = null;
          this.purchasedProductEndDate = null;

          this.selectedQuotesSearchType = DefaultDocFilterType.QuoteNumber;
          this.selectedOrdersSearchType = DefaultDocFilterType.OrderNumber;
          this.selectedTempOrdersSearchType = DefaultDocFilterType.OrderNumber;
          this.selectedInvoicesSearchType = DefaultDocFilterType.InvoiceNumber;
          this.selectedCreditSearchType = DefaultDocFilterType.CreditNoteNumber;
          this.quotesFilter = [];
          this.ordersFilter = [];
          this.tempOrdersFilter = [];
          this.invoicesFilter = [];
          this.creditFilter = [];
          break;
    }
  }
}
